import { UnderConstructionPage } from '@components/app/UnderConstructionPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/classes/$classId/references')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'References'
        }
    }
})

function RouteComponent() {
    return <UnderConstructionPage />
}
